/**
 * base on library/Acl/Permission.php
 */

export const PERMISSIONS = {
  SEND_MESSAGE_TO_CANDIDATES: 'SendMessagesToCandidates',
  MANAGE_INBOUNDS_REQUIREMENTS: 'ManageInboundsRequirements',
  ADD_EMPLOYEE_REVIEW: 'AddEmployeeReview',
  ADD_INTERVIEW_REVIEW: 'AddInterviewReview',
  ADD_OVERVIEW_REVIEW: 'AddOverviewReview',
  PROJECT_VIEW_APPLICANTS: 'ProjectViewApplicants',
  PROCESS_VIEW_APPLICANTS: 'ProcessViewApplicants',
  CREATE_HIDDEN_PROCESS: 'CreateHiddenProcess',
  CHANGE_CANDIDATES_STATUS: 'ChangeCandidatesStatus',
  RATED_CANDIDATES: 'RateCandidates',
  VIEW_PRICE_CANDIDATE_PREMIUM: 'ViewPriceCandidatePremium',
  CREATE_CANDIDATE_ACCOUNT: 'CreateCandidateAccount',
  CLOSED_SEARCH: 'ClosedSearch',
  EDIT_CANDIDATE_PROFILE: 'EditCandidateProfile',
  EDIT_FIRM_PROFILE: 'EditFirmProfile',
  CANDIDATE_PROFILE_ATTACHMENTS: 'CandidateProfileAttachments',
  CHANGE_MULTIPLE_CANDIDATES_STATUS: 'ChangeMultipleCandidatesStatus',
  SEND_CANDIDATE_NOTIFY: 'SendCandidateNotify',
  USE_PROCESS_ALL_SEARCHES_SORT: 'UseProcessAllSearchesSort',
  USE_NETWORK_FILTERS: 'UseNetworkFilters',
  VIEW_FIRM_EMPLOYEES: 'ViewFirmEmployees',
  VIEW_GAT_PERCENTILE: 'ViewGATPercentile',
  VIEW_PROCESS_APPLY_REQUIREMENTS_MISMATCH:
    'ViewProcessApplyRequirementsMismatch',
  DELETE_CANDIDATE_POSITION: 'DeleteCandidatePosition',

  RATED: 'Rated',
  INBOUNDS: 'InBounds',
  PROCESS: 'Process',
  PROJECT: 'Project',
  SHORTLIST: 'Shortlist',
  SUBSCRIPTION_SEARCHES: 'SubscriptionSearches',
  MY_TEAM: 'MyTeam',
  TEAM_PROFILE_VIEWS: 'TeamProfileViews',
  POST_JOB: 'PostJob',
  POST_PROJECT: 'PostProject',

  VIEW_OWN_PROFILE: 'ViewOwnProfile',
  MANAGE_JOBS: 'ManageJobs',
  MANAGE_PROJECTS: 'ManageProjects',
  CANDIDATES_SHORTLISTS: 'CandidatesShortlists',
  PREPARATORY_FILES: 'PreparatoryFiles',
  PERSONAL_CALENDAR: 'PersonalCalendar',
  RUN_APTITUDE_TEST: 'RunAptitudeTest',
  USE_PROCESS_SETUP_EMAIL: 'UseProcessSetupEmail',
  USE_EMAIL_TEMPLATE_FOLLOWUP: 'UseEmailTemplateFollowup',
  MASS_SEND_JOB: 'MassSendJob',
  USE_QUICK_FILTERS: 'UseQuickFilters',
};

export default PERMISSIONS;
